import * as React from "react"

import { DatoImage } from "../../shared-components/dato-image"
import * as styles from "./index.module.scss"

type Props = {
  url: string
  name?: string
  variant?: "small" | "medium" | "large"
}

const sizeMap: Record<Exclude<Props["variant"], undefined>, number> = {
  small: 50,
  medium: 56,
  large: 80,
}

function Avatar({ url, name = "", variant = "medium" }: Props) {
  const size = sizeMap[variant]

  return (
    <DatoImage
      className={styles.avatarImage}
      fadeInDuration={0}
      data={{
        width: size,
        height: size,
        alt: name,
        src: `${url}?auto=format&fit=max&dpr=2&q=80`,
      }}
      srcSetCandidates={[{ imgWidth: size, minViewport: 0 }]}
      style={{
        minWidth: size,
      }}
    />
  )
}

export default Avatar
